import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DigitalIdentityTrustStatus } from 'queries';

type Props = {
  efxDigitalIdentityTrust?: DigitalIdentityTrustStatus;
};

const useStyles = makeStyles(() => ({
  error: {
    color: 'red',
  },
  success: {
    color: 'green',
  },
}));

export default function DitStatusLabel({ efxDigitalIdentityTrust }: Props) {
  const classes = useStyles();
  const className = efxDigitalIdentityTrust === 'APPROVE' ? 'success' : 'error';
  return efxDigitalIdentityTrust ? (
    <Typography variant="caption" className={classes[className]}>
      DIT: {efxDigitalIdentityTrust}
    </Typography>
  ) : (
    <></>
  );
}
